export function loadLetterHome() {
  return {
    type: 'LOAD_LETTER_HOME',
  };
}

export function loadLetterHomeCompletion(error, data) {
  return {
    type: 'LOAD_LETTER_HOME_COMPLETION',
    error,
    data,
  };
}

export function syncLetterAgentInput(input, reset) {
  return {
    type: 'SYNC_LETTER_AGENT_INPUT',
    input,
    reset,
  };
}

export function editLetterAgent() {
  return {
    type: 'EDIT_LETTER_AGENT',
  };
}

export function editLetterAgentCompletion(error = null, data = {}) {
  return {
    type: 'EDIT_LETTER_AGENT_COMPLETION',
    error,
    data,
  };
}
